import React from "react";

const Stat_Variation = () => {
  return (
    <div>
      <h1>Stat Variation</h1>
    </div>
  );
};

export default Stat_Variation;
